import { Disclosure } from '@headlessui/react'
import { ReactElement } from 'react'
import { formatDate, isTodayOrLater } from '../../../date.utils'
import { ContactJson } from 'app/types/entities'
import { ChevronToggle } from '../../ChevronToggle'

type Props = {
  contact: ContactJson
  isIntegrated: boolean
}

export default function ContactSectionsV2({ contact, isIntegrated }: Props): ReactElement | null {
  if (!isIntegrated) return null

  const round = (value: number, precision: number) => {
    var multiplier = Math.pow(10, precision || 0)
    const rounded = Math.round(value * multiplier) / multiplier
    if (rounded >= 1000) {
      return `${round(rounded / 1000, 1)}k`
    } else {
      return `$${rounded}`
    }
  }

  return (
    <div className="flex flex-col gap-y-4 rounded-md bg-surface p-4">
      <Disclosure defaultOpen>
        {({ open }) => (
          <>
            <Disclosure.Button className="flex w-full items-center gap-x-2">
              <div className="text-heading-xs text-strong">Stats</div>
              <ChevronToggle open={open} />
            </Disclosure.Button>
            <Disclosure.Panel>
              <>
                <div className="grid grid-cols-2 gap-1">
                  <div className="flex flex-col gap-y-1 rounded-lg border border-subtle bg-surface-subtle p-3">
                    <span className="text-body-xs text-subtle">Became a Lead</span>
                    <span className="text-ui-xs text-strong">
                      {formatDate({ value: contact.becameLeadDate, dateOnly: true }) || `-`}
                    </span>
                  </div>
                  <div className="flex flex-col gap-y-1 rounded-lg border border-subtle bg-surface-subtle p-3">
                    <span className="text-body-xs text-subtle">Became a Patient</span>
                    <span className="text-ui-xs text-strong">
                      {formatDate({ value: contact.becamePatientDate, dateOnly: true }) || `-`}
                    </span>
                  </div>
                  <div className="flex flex-col gap-y-1 rounded-lg border border-subtle bg-surface-subtle p-3">
                    <span className="text-body-xs text-subtle">Last Appointment</span>
                    <span className="text-ui-xs text-strong">
                      {formatDate({ value: contact.lastAppointmentDate, dateOnly: true }) || `-`}
                    </span>
                  </div>
                  <div className="flex flex-col gap-y-1 rounded-lg border border-subtle bg-surface-subtle p-3">
                    <span className="text-body-xs text-subtle">Next Appointment</span>
                    <span className="text-ui-xs text-strong">
                      {formatDate({
                        value: isTodayOrLater(contact.nearestAppointmentDate)
                          ? contact.nearestAppointmentDate
                          : undefined,
                        dateOnly: true,
                      }) || `-`}
                    </span>
                  </div>
                  <div className="flex flex-col gap-y-1 rounded-lg border border-subtle bg-surface-subtle p-3">
                    <span className="text-body-xs text-subtle">Net Production</span>
                    <span className="text-ui-xs text-strong">{round(contact.productionLtv || 0, 0)}</span>
                  </div>
                  <div className="flex flex-col gap-y-1 rounded-lg border border-subtle bg-surface-subtle p-3">
                    <span className="whitespace-nowrap text-body-xs text-subtle">Scheduled Production</span>
                    <span className="text-ui-xs text-strong">{round(contact.scheduledProduction || 0, 0)}</span>
                  </div>
                </div>
              </>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  )
}
